<script lang="ts" setup>
defineProps<{ params: { attributes: { title: string; value: string } }[] }>();
</script>

<template>
  <div class="constructor-data-list">
    <div
      v-for="(param, key) in params"
      :key="param.attributes.title + key"
      class="constructor-data-list__item"
    >
      <div>{{ param.attributes.title }}</div>
      <div class="constructor-data-list__item-underline" />
      <div>{{ param.attributes.value }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.constructor-data-list {
  @include inner-content;

  gap: 8px;

  &__item {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  &__item-underline {
    flex-grow: 1;
    margin: 2.5px;
    border-bottom: 1px dotted $black-40;
  }
}
</style>
